import { API } from 'utils/api.config';
export async function getPage(slug) {
  return await API.get(`/api/pages/${slug}`);
}
